import { Helmet } from 'react-helmet-async';
// sections
import { HomeView } from 'src/sections/home/view';

// ----------------------------------------------------------------------

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>Đại Học Tân Tạo: Hệ thống tra cứu văn bằng chứng chỉ</title>
      </Helmet>

      <HomeView />
    </>
  );
}
